import { environment } from 'apps/dialect/src/environments/environment';
import { BehaviorSubject, map, tap } from 'rxjs';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { ISalesChannelAuthorizationResponse } from '../interfaces/sales-channel-authorization-response.interface';

@Injectable({ providedIn: 'root' })
export class SalesChannelService {
  private readonly SESSION_STORAGE_AUTHORIZATION_KEY = 'dialects/sales-channel/authorization';
  private readonly http = inject(HttpClient);
  private readonly api = environment.gateway.external;
  private _credentials$ = new BehaviorSubject<string | null>(null);

  constructor() {
    this._credentials$.next(sessionStorage.getItem(this.SESSION_STORAGE_AUTHORIZATION_KEY) || null);
  }

  get credentials$() {
    return this._credentials$.asObservable();
  }

  authorize(clientId: string, clientSecret: string) {
    const body = new HttpParams().set('grant_type', 'client_credentials').set('client_id', clientId).set('client_secret', clientSecret);

    return this.http
      .post<ISalesChannelAuthorizationResponse>(`${this.api}/auth/v1/token`, body.toString(), {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      })
      .pipe(
        map((response) => response.access_token),
        tap((token) => this._credentials$.next(token)),
        tap((token) => sessionStorage.setItem(this.SESSION_STORAGE_AUTHORIZATION_KEY, token))
      );
  }

  logout() {
    this._credentials$.next(null);
    sessionStorage.clear();
  }
}
